<template>
  <div class="mb-20">
    <div class="d-flex flex-row flex-wrap justify-content-center align-items-center mt-5">
      <div style="display: flex" v-if="data.events.departure">
        <div style="border-radius: 60px">
          <button id="button02" class="tracking-point-departure">
            <i class="fas fa-warehouse" style="padding-bottom: 20px"></i>
          </button>
        </div>
      </div>

      <div style="width: 200px" class="tracking-line-active" v-if="data.events.current"></div>

      <div style="display: flex" v-if="data.events.current">
        <div style="border-radius: 60px">
          <button id="button03" class="tracking-point-current">
            <i class="fa fa-ship" style="padding-bottom: 20px"></i>
          </button>
        </div>
      </div>

      <div style="width: 200px" class="tracking-line-active" v-if="data.events.arrival"></div>

      <div style="display: flex" v-if="data.events.arrival">
        <div style="border-radius: 60px">
          <button id="button04" class="tracking-point-arrival"
                  :style="{border: `3px solid ${data.events.arrival.row_color}`, background: data.events.arrival.row_color}">
            <i class="fas fa-map-marker-alt" style="padding-bottom: 20px"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="d-flex flex-row flex-wrap justify-content-center align-items-center mb-5">
      <div class="description-text mt-2" v-if="data.events.departure">
        <small>
          Salida:
        </small>
        <p>
          <strong>
            {{ data.events.departure.movement_location + " - " + data.events.departure.port_name }} <br>
            {{ data.events.departure.date_type_name }} <br>
            {{ data.events.departure.movement_location_date }}
          </strong>
        </p>
      </div>
      <div class="description-text mt-2" v-if="data.events.current">
        <small>
          Fecha acordada:
        </small>
        <p>
          <strong>
            {{ data.pod && data.pod_eta ? data.pod_eta + " - " + data.pod : "N/A" }} </strong>
        </p>
      </div>
      <div class="description-text mt-2" v-if="data.events.arrival">
        <small>Llegada:</small>
        <p>
          <strong>
            {{ data.events.arrival.movement_location + " - " + data.events.arrival.port_name }}<br>
            {{ data.events.arrival.date_type_name }}<br>
            {{ data.events.arrival.movement_location_date }}
            <span v-if="usuarioActual.id_role === 1 || usuarioActual.id_role === 9999 || usuarioActual.id_role === 2 || usuarioActual.id_role === 5">
              ({{ data.diff_in_days + ' ' + data.timing_status }})
          </span>
          </strong>
        </p>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from "vuex";

export default {
  props: {
    data: {}
  },
  methods: {},
  computed: {
    ...mapState(["usuarioActual"])
  },
  created() {}
};

</script>

<style>

.tracking-point-departure {
  width: 115px;
  height: 115px;
  border-radius: 60px;
  border: 3px solid #5D95B6FF;
  background-color: #5D95B6FF;
  text-align: center;
  color: #ffffff;
  font-size: 45px;
  padding-top: 13px;
}

.tracking-point-current {
  width: 115px;
  height: 115px;
  border-radius: 60px;
  border: 3px solid #308671FF;
  background-color: #308671FF;
  text-align: center;
  color: #ffffff;
  font-size: 45px;
  padding-top: 13px;
}

.tracking-point-arrival {
  width: 115px;
  height: 115px;
  border-radius: 60px;
  color: #ffffff;
  text-align: center;
  font-size: 45px;
  padding-top: 13px;
}

.tracking-line-active {
  height: 2.5pt;
  background: linear-gradient(90deg, #ffffff, #ffffff);
}

.description-text {
  width: 320px;
  height: 20px;
  text-align: center;
  font-size: 14px;
  margin-bottom: 50px;
}

</style>
